<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         :show.sync="show"
      >
         <CRow>
            <CCol>
               <CRow class="mt-3">
                  <CCol
                     ><label>
                        {{ "Category Class :" }}
                        <CBadge v-if="form.is_publish == 2" color="danger"
                           >Private</CBadge
                        >
                        <CBadge v-if="form.is_publish == 1" color="success"
                           >Public</CBadge
                        >
                     </label>
                  </CCol>
               </CRow>

               <hr />
               <CRow>
                  <CCol>
                     <label>
                        {{ "Classname:" }} <b> {{ form.name }} </b>
                     </label>
                  </CCol>
               </CRow>
               <hr />

               <CRow>
                  <CCol
                     ><label>
                        {{ "Description :" }} <b>{{ form.description }} </b>
                     </label>
                  </CCol>
               </CRow>
               <hr />

               <CRow>
                  <CCol
                     ><label>
                        {{ "Type Class :"
                        }}<b>
                           <label v-if="form.type == 1" color="danger"
                              >Singleclass</label
                           >
                           <label v-if="form.type == 2" color="success"
                              >Multiclass</label
                           >
                        </b>
                     </label>
                  </CCol>
               </CRow>
               <hr />
               <CRow>
                  <CCol
                     ><label>
                        {{ "Batch :" }}
                        <b> {{ getClassName(form.class_batch) }} </b>
                     </label>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>
         <template #footer>
            <CButton @click="show = false" color="danger">Close</CButton>
         </template>
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";
import classtemplate from "@/services/class_template";
import classbatch from "@/services/batch";

export default {
   name: "visitormodal",

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         class_batch: [],
         batch_name: [],
         form: {
            id: "",
            name: "",
            description: "",
            is_publish: "",
            type: "",
            class_batch: "",
         },
      };
   },
   computed: {},
   mounted() {},
   created() {
      var self = this;
      EventBus.$on("OPEN_DETAIL_CLASS", (params) => {
         if (params.data) {
            classtemplate
               .getTemplatebyID(params.data)
               .then((res) => {
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.id = res.data.id;
                  self.form.name = res.data.name;
                  self.form.description = res.data.description;
                  self.form.is_publish = res.data.is_publish;
                  self.form.type = res.data.type;
                  self.form.class_batch = res.data.class_batch.id;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.id = "";
            self.form.name = "";
            self.form.description = "";
            self.form.is_publish = "";
            self.form.type = "";
            self.form.class_batch.id = "";
         }
      });
      classbatch.getBatch().then((res) => {
         //this.classname = res.data
         for (let i = 0; i <= res.data.length - 1; i++) {
            this.class_batch.push(res.data[i].id);
            this.batch_name.push(res.data[i].name);
         }
      });
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      getClassName(temp) {
         return this.batch_name[this.class_batch.indexOf(temp)];
      },
   },
};
</script>
